import { AppRoute } from 'app/app-layout/constants';

import { NavCategoryId } from './nav-category-ids.enum';

export interface NavItemInterface {
  labelId?: string;
  categoryId?: NavCategoryId;
  route?: AppRoute;
}

export class NavItem implements NavItemInterface {
  public labelId?: string;
  public categoryId?: NavCategoryId;
  public route?: AppRoute;

  constructor({
    labelId = undefined,
    categoryId = undefined,
    route = undefined,
    }: NavItemInterface) {
    this.labelId = labelId;
    this.categoryId = categoryId;
    this.route = route;
  }
}
